import * as accountsApi from '@/network/api/accounts.api.js'
import * as signedApi from '@/network/api/operations/signed.api.js'
import * as operationsApi from '@/network/api/operations/operations.api.js'

/** requests accounts balances
@return { promise } - Accounts balances request
*/
export const requestAccountsBalances = async (context, payload) => {
    const res = await accountsApi.requestAccountsBalances()
    if (res) {
        const data = res.data.data
        context.commit('SAVE_ACCOUNTS_BALANCE', data)
    }
    return res
}

/** requests operation approvals list
@return { promise } - Operation approvals request
*/
export const requestOperationApprovalsList = async (context, payload) => {
    const res = await signedApi.getOperationApprovalsList(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_OPERATION_APPROVALS_LIST', { pageNumber: payload.pageNumber, data: data })
    }
    return res
}

/** requests accounts with operations pending signature
@return { promise } - Accounts request
*/
export const requestAccountsWithOperationsPendingSignature = async (context, payload) => {
    const res = await signedApi.getAccountsWithOperationsPendingSignature()
    if (res) {
        const data = res.data.data
        context.commit('SAVE_ACCOUNTS_WITH_OPERATIONS_PENDING_SIGNATURE', data)
    }
    return res
}

/** request to cancel operation
@return { promise } - Cancel operation request
*/
export const cancelOperation = async (context, payload) => {
    const res = await operationsApi.cancelOperation(payload)

    return res
}

/** request to sign operations
@return { promise } - Sign multiple operations request
*/
export const requestSignMultipleOperations = async (context, payload) => {
    const res = await signedApi.signMultipleOperations(payload)

    return res
}

/** Clear accounts accounts with operations pending signature */
export const clearAccountsWithOperationsPendingSignature = (context, payload) => {
    context.commit('SAVE_ACCOUNTS_WITH_OPERATIONS_PENDING_SIGNATURE', [])
}

/** Clear operation approvals list */
export const clearOperationApprovalsList = (context, payload) => {
    context.commit('SAVE_OPERATION_APPROVALS_LIST', { pageNumber: null, data: [] })
}
